import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DefaultError from './DefaultError';

const INITIAL_STATE = {
  error: null,
  key  : 0,
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  cleanError = () => {
    this.setState(({ key }) => ({ ...INITIAL_STATE, key: key + 1 }));
    this.forceUpdate();
  };

  componentDidCatch(error) {
    this.setState({
      error,
    });
  }

  render() {
    const { children, ErrorComponent } = this.props;
    const { error, key } = this.state;

    return error ? (
      <ErrorComponent cleanError={this.cleanError} error={error} />
    ) : (
      <Fragment key={key}>{children}</Fragment>
    );
  }
}

ErrorBoundary.propTypes = {
  children      : PropTypes.node.isRequired,
  ErrorComponent: PropTypes.func,
};

ErrorBoundary.defaultProps = {
  ErrorComponent: DefaultError,
};

export default ErrorBoundary;
